import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useGetAll, useGetOne } from "./crudService";
import { authenticatedApi } from "api";
import { useUpdate } from "./crudService/useUpdate";

const endpoint:string = 'notifications';

interface IGetNotification {
    page?:number,
    seen?:number,
};

export function useGetAllNotifications(params:IGetNotification, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useUpdateNotification(id:string|number/*, params:any*/) {
    return useUpdate({queryKey: [endpoint, id]}/*, params*/);
}

export function useClearNotification({id}) {
    // return useGetOne({queryKey: [endpoint]}, params);
    const queryClient = useQueryClient();

    // When this mutation succeeds, invalidate any queries with the `todos` or `reminders` query key
    return useMutation({
        mutationFn: async () => {
            const { data } = await authenticatedApi.put(`/${endpoint}/${id}`, {seen: 1});
            return data;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [endpoint] })
            // queryClient.invalidateQueries({ queryKey: ['reminders'] })
        },
    })
}

export function useClearNotifications() {
    // return useGetOne({queryKey: [endpoint]}, params);
    const queryClient = useQueryClient();

    // When this mutation succeeds, invalidate any queries with the `todos` or `reminders` query key
    return useMutation({
        mutationFn: async () => {
            const { data } = await authenticatedApi.post(`/${endpoint}/clear`);
            return data;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [endpoint] })
            // queryClient.invalidateQueries({ queryKey: ['reminders'] })
        },
    })
}
